export type RetryStrategy = {
    retries?: number;
    backoff?: number;
    retryOnStatus?: number[];
    maxBackoff?: number;
    timeout?: number; // 新增超时参数
};

export async function ReliableFetch(
    input: RequestInfo,
    init: RequestInit = {},
    retryStrategy: RetryStrategy = {}
): Promise<Response> {

    // 非幂等不能随便重连，暂时还是用原始的吧
    return await fetch(input, init);


    const {
        retries = 3,
        backoff = 500,
        retryOnStatus = [408, 429, 500, 502, 503, 504],
        maxBackoff = 5000,
        timeout = 8000, // 默认超时 8 秒
    } = retryStrategy;

    let wait = backoff;

    for (let attempt = 0; attempt <= retries; attempt++) {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeout);

        try {
            const response = await fetch(input, {
                ...init,
                signal: controller.signal,
            });

            clearTimeout(timeoutId);

            // ✅ 2xx 响应，直接返回
            if (response.ok) return response;

            // ❌ 非重试状态码，抛出错误
            if (!retryOnStatus.includes(response.status)) {
                throw new Error(`HTTP ${response.status} - 不可重试状态码`);
            }

            // ❗可重试的状态码
            throw new Error(`HTTP ${response.status} - 可重试错误`);

        } catch (err) {
            clearTimeout(timeoutId);

            // 最后一次重试后抛出错误
            if (attempt === retries) {
                const error = err instanceof Error ? err : new Error("未知网络错误");
                error.message = `最终请求失败（尝试 ${retries + 1} 次）: ${error.message}`;
                throw error;
            }

            // 网络错误或可重试状态码，等待后重试
            console.warn(`[ReliableFetch] 第 ${attempt + 1} 次尝试失败，等待 ${wait}ms 后重试...`, err);
            await new Promise((resolve) => setTimeout(resolve, wait));
            wait = Math.min(wait * 2, maxBackoff);
        }
    }

    throw new Error("逻辑不应执行到此处");
}